import { z } from 'zod';

import { requiredFieldError, requiredString } from '../../helper';
import { AddressState } from '../../types';

export const address = z.object({
  unitNumber: z.string().trim().optional(),
  streetNumber: requiredString('STREET_NUMBER'),
  streetName: requiredString('STREET_NAME'),
  suburb: requiredString('SUBURB'),
  state: z.nativeEnum(AddressState, {
    errorMap: () => ({
      message: requiredFieldError('State'),
    }),
  }),
  postcode: requiredString('POSTCODE').length(4, requiredFieldError('POSTCODE')),
  fullAddress: z.string().trim().optional(),
});
